<template>
    <div class="foot">
        <p>&copy; 2018 Kenyatta University Christian Union Developers Group.</p>
    </div>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

<style scoped>
.foot{
    height: 70px;
    width: 100%;
    background-color: #000;
    margin-top: 0px;
}
p{
    color: #ffffff;
    text-align: center;
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue